import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkUpdateTriageRequestByNoteId } from '../types';

const onUpdateTriageRequestByNoteId: IThunkUpdateTriageRequestByNoteId = thunk(
  // @ts-ignore
  async ({ setTriageRequest }, { noteId, values }) => {
    const { data } = await api.triage.updateRequestByNoteId(noteId, values);

    setTriageRequest(data);
  },
);

export default onUpdateTriageRequestByNoteId;
